import React from 'react'
import { IoClose } from 'react-icons/io5'

const TranscriptModal = ({content,closeModal}) => {
    return (
        <div className='h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center'>
            <div className='flex flex-col items-end modalAnimation w-[800px] max-w-[85%] h-[80vh]'>
                <div onClick={closeModal} className='bg-white cursor-pointer z-30 mb-[10px] rounded-full p-[2px]'><IoClose /></div>
                <div className={`rounded-md bg-white border-box w-full relative p-[15px] flex-grow text-sm sm:text-base overflow-auto overflow-x-hidden`}>
                {content ? <pre className='text-sm whitespace-break-spaces w-full h-full text-gray-600 overflow-auto'>{content}</pre> : "Transcript file not found"}
                </div>
            </div>
        </div>
    )
}
export default TranscriptModal